import { createContext } from 'react';
import { CommonSettingsContextProps } from './props';

/**
 * CommonSettingsContext
 * This context is used to provide common settings throughout the application.
 * It uses the createContext function from React to create a context with a default value of null.
 *
 * @type {React.Context<CommonSettingsContextProps | null>}
 *
 * @example
 * // Example usage:
 * import { CommonSettingsContext } from './path/to/CommonSettingsContext';
 *
 * function App() {
 *   const commonSettings = useContext(CommonSettingsContext);
 *   return (
 *     <div>
 *       {commonSettings ? (
 *         <p>Settings are available</p>
 *       ) : (
 *         <p>No settings available</p>
 *       )}
 *     </div>
 *   );
 * }
 */
export const CommonSettingsContext =
  createContext<CommonSettingsContextProps | null>(null);
